
let mallItemStatus = val => {
  return val == 0 ? "下架" : "上架";
}

let itemStatus = val => {
  return val == 1 ? "启用" : "暂停";
}

let attrFilter = val => {
  let attrObj = ["链接","卡密","实物","兑换码","话费","流量"];
  return attrObj[val]
}

let pwdFilter = name => {
    var pwd='';
    switch (name) {
        case 'root':
            pwd = 'root123456'
            break;
        case 'admin':
            pwd = 'admin123456'
            break;
        case 'operate':
            pwd = '123456'
            break;
        default :
            pwd = ''
    }
    return pwd;
}
export {
  mallItemStatus,
  itemStatus,
  attrFilter,
  pwdFilter
}



// WEBPACK FOOTER //
// ./src/filters/index.js